import React from 'react';
import ReactTooltip from 'react-tooltip';
import { isSome } from 'core/utils';
import { defaultTemplate } from 'core/hoc';

function BaasicTableActionsTemplate({ item, actions, t }) {
	if (!isSome(actions)) return null;

	const { onEdit, onDelete } = actions;
	if (!isSome(onEdit) && !isSome(onDelete)) return null;

	return (
		<td className="table__body--data right hoverable">
			{isSome(onEdit) ? (
				<i data-tip={t('EDIT')} className="fa fa-edit spc--right--sml" onClick={() => onEdit(item)}>
					<ReactTooltip />
				</i>
			) : null}
			{isSome(onDelete) ? (
				<i data-tip={t('DELETE')} className="fa fa-trash spc--right--sml" onClick={() => onDelete(item)}>
					<ReactTooltip />
				</i>
			) : null}
		</td>
	);
}

export default defaultTemplate(BaasicTableActionsTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/table/BaasicTableActionsTemplate.jsx